import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Modal } from "antd";
import PropTypes from "prop-types";
import ParcelaField from "../ParcelaField";
import DateField from "../DataField";
import parcelaChange from "../../../store/actions/acordo/parcela/change";
import dataChange from "../../../store/actions/acordo/data/change";
import { format as formatCurrency } from "../../../utils/MoneyFormater";

class ParcelaForm extends Component {
  /**
   * Informações recebidas por prop
   */
  static propTypes = {
    valorAcordo: PropTypes.number,
    acordo: PropTypes.string,
    qntParcelas: PropTypes.number,
    valorEntrada: PropTypes.number,
    hasValorEntrada: PropTypes.bool
  };

  state = {
    emptyText: "...",
    data: [],
    parcelas: {}
  };

  UNSAFE_componentWillReceiveProps(prevProps) {
    /**
     * Evento chamado quando o componente pai
     * possui algum estado alterado, e se possuir, é feita uma
     * verificação no valor do acordo, caso tenha sido alterado, atualiza a lista de parcelas.
     */
    const valorAcordo = this.props.valorAcordo;
    const prevValorAcordo = prevProps.valorAcordo;
    const qntParcelas = this.props.qntParcelas;
    const prevQntParcelas = prevProps.qntParcelas;
    const valorEntrada = this.props.valorEntrada;
    const prevValorEntrada = prevProps.valorEntrada;
    const hasValorEntrada = this.props.hasValorEntrada;
    const prevHasValorEntrada = prevProps.hasValorEntrada;

    if (
      valorAcordo != prevValorAcordo ||
      qntParcelas != prevQntParcelas ||
      valorEntrada !== prevValorEntrada ||
      hasValorEntrada !== prevHasValorEntrada
    ) {
      this.handleParcelas(prevProps);
    }
  }

  /**
   * Datas dinamicas
   * @param {Date} date - Data selecionada
   * @param {Number} index - Número da data que foi alterada
   */
  handleDateChange = (date, index) => {
    /**
     * Itera sobre todas as datas depois da data alterada,
     * e acrescenta +1 no mês.
     * Verifica o dia, se for sábado, seta o "day" + 2, caso for domingo,
     * "day" + 1.
     */
    const day = date.getDate() + 1;

    /**
     * Variável que as outras datas irão receber para atualizarem seu valor
     * caso o index da data contenha nesse objeto, ela irá ser atualizada.
     */
    let updateObject = {};

    for (let i = index + 1; i <= this.props.qntParcelas; i++) {
      date.setDate(day);
      date.setMonth(date.getMonth() + 1);

      /** Verifica se é sábado ou domingo */
      if (date.getDay() == 0) {
        date.setDate(day + 1);
      }
      if (date.getDay() == 6) {
        date.setDate(day + 2);
      }

      let dtString = date.toLocaleDateString().split("/");
      let finalDate = `${dtString[2]}-${dtString[1]}-${dtString[0]}`; // 0000-00-00

      updateObject[i] = {
        value: finalDate
      };
    }

    /** Chama a action do redux para "distribuição" dos novos valores */
    this.props.dispatch(dataChange(updateObject));
  };

  /**
   * Função chamada quando o valor de uma parcela
   * é alterado
   * @param {Number} value - Novo valor da parcela
   * @param {Number} numParcela - Número da parcela que foi alterada
   */
  handleParcelaChange = (value, numParcela) => {
    if (isNaN(value) || value === 0) {
      value = 0.0;
    }

    // A soma de todas as parcelas não pode ser maior que o valor do acordo!
    let soma = value;
    let parcelasAnteriores = 0;

    for (let parcela in this.state.parcelas) {
      // if (parcela != numParcela) {
      //   soma += parseFloat(this.state.parcelas[parcela].valor_parcela);
      // }
      /** Soma o valor das parcelas anteriores a modificada */
      if (parseInt(parcela) < parseInt(numParcela)) {
        parcelasAnteriores += parseFloat(
          this.state.parcelas[parcela].valor_parcela
        );
      }
    }

    soma += parcelasAnteriores; // Valor atual + valor das parcelas anteriores

    let valorAcordo = parseFloat(this.props.valorAcordo);
    let parcelasValue =
      (valorAcordo - (parcelasAnteriores + value)) /
      (this.props.qntParcelas - numParcela);

    if (parcelasValue <= 0) {
      parcelasValue = 0;
    }

    soma += parcelasValue * (this.props.qntParcelas - numParcela);

    if (soma > this.props.valorAcordo) {
      Modal.error({
        title: "Erro",
        content: "A soma das parcelas não pode ultrapassar o valor do acordo!"
      });
    }

    /**
     * Variável que as outras parcelas irão receber para atualizarem seu valor
     * caso o número da parcela contenha nesse objeto, ela irá modificar seu valor.
     */
    let updateObject = {};
    let parcelas_ant = this.state.parcelas;

    for (let i = numParcela + 1; i <= this.props.qntParcelas; i++) {
      updateObject[i] = {
        value: parcelasValue
      };

      parcelas_ant[i] = {
        valor_parcela: parcelasValue
      };
    }

    parcelas_ant[numParcela] = {
      valor_parcela: value
    };

    this.setState({
      parcelas: parcelas_ant
    });

    /** Chama a action do redux para "distribuição" dos novos valores */
    this.props.dispatch(parcelaChange(updateObject));
  };

  /**
   * Monta o formulário de parcelas
   */
  handleParcelas = (props = this.props) => {
    const valor = parseFloat(props.valorAcordo) - props.valorEntrada;
    const parcelas = parseInt(props.qntParcelas);
    const data = [];

    // Valor entrada = parcela fixa "0" sem alteração
    if (props.hasValorEntrada) {
      const dtString = new Date().toLocaleDateString().split("/");
      const finalDate = `${dtString[2]}-${dtString[1]}-${dtString[0]}`;

      data.push({
        key: 0,
        numeroParcela: 0,
        dataVencimento: (
          <DateField
            onChangeEvent={this.handleDateChange}
            name={`date_0`}
            numParcela={0}
            acordo={this.props.acordo}
            value={finalDate}
          />
        ),
        valorParcela: `R$ ${formatCurrency(props.valorEntrada)}`
      });

      this.setState({
        data
      });
    }

    if (parcelas > 0) {
      if (valor >= 10.0) {
        /** Valor por parcela */
        const parcelaValue = parseFloat(valor / parcelas);

        /** Date field */
        const date = new Date();
        const day = date.getDate();
        const parcelas_obj = {};

        for (let i = 1; i <= parcelas; i++) {
          date.setDate(day);

          /** Verifica se é sábado ou domingo */
          if (date.getDay() == 0) {
            date.setDate(day + 1);
          }
          if (date.getDay() == 6) {
            date.setDate(day + 2);
          }

          const dtString = date.toLocaleDateString().split("/");
          const finalDate = `${dtString[2]}-${dtString[1]}-${dtString[0]}`; // 0000-00-00

          parcelas_obj[i] = {
            valor_parcela: parcelaValue
          };

          data.push({
            key: i,
            numeroParcela: i,
            dataVencimento: (
              <DateField
                onChangeEvent={this.handleDateChange}
                name={`date_${i}`}
                numParcela={i}
                acordo={this.props.acordo}
                value={finalDate}
              />
            ),
            valorParcela: (
              <ParcelaField
                name={`parcela_${i}`}
                valorParcela={parcelaValue}
                acordo={this.props.acordo}
                valorAcordo={parseFloat(this.props.valorAcordo)}
                numParcela={i}
                changeFunction={this.handleParcelaChange}
              />
            )
          });

          date.setMonth(date.getMonth() + 1);
        }

        this.setState({
          data,
          parcelas: parcelas_obj
        });
      } else {
        this.setState({
          emptyText: "Defina o valor do acordo",
          data: []
        });
      }
    } else {
      this.setState({
        emptyText: "Selecione a quantidade de parcelas",
        data: []
      });
    }
  };

  render() {
    const columns = [
      {
        title: <b>{"Número parcela"}</b>,
        dataIndex: "numeroParcela",
        key: "numeroParcela",
        render: text => (text === 0 ? <b>Entrada</b> : <b>{text}º</b>)
      },
      {
        title: <b>{"Valor parcela"}</b>,
        dataIndex: "valorParcela",
        key: "valorParcela"
      },
      {
        title: <b>{"Data de vencimento"}</b>,
        dataIndex: "dataVencimento",
        key: "dataVencimento"
      }
    ];

    return (
      <div>
        <Table
          columns={columns}
          className="acordo__table"
          bordered
          locale={{ emptyText: this.state.emptyText }}
          dataSource={this.state.data}
          pagination={false}
        />
      </div>
    );
  }
}
export default connect(state => ({
  parcelas: state.acordo
}))(ParcelaForm);



// WEBPACK FOOTER //
// ./src/components/Acordo/ParcelaForm/index.js